import { Link, useRouterState } from '@tanstack/react-router';
import { cn } from '../lib/utils.js';
import { MODULES } from '@aos/shared';

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

export function Sidebar({ open, onClose }: SidebarProps) {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;

  return (
    <aside
      className={cn(
        // Base styles
        'w-60 shrink-0 bg-zinc-900 border-r border-zinc-800 flex flex-col',
        // Mobile: fixed overlay, hidden by default
        'fixed inset-y-0 left-0 z-50 transition-transform duration-300 md:relative md:translate-x-0',
        open ? 'translate-x-0' : '-translate-x-full',
      )}
    >
      {/* Logo */}
      <div className="h-16 flex items-center px-6 border-b border-zinc-800 shrink-0">
        <span className="text-xl font-bold text-blue-500">AOS</span>
        <span className="text-xl font-semibold text-slate-100 ml-1">Platform</span>
      </div>

      {/* Nav */}
      <nav className="flex-1 py-4 overflow-y-auto">
        <ul className="space-y-1 px-3">
          {MODULES.map((mod) => {
            const isActive = currentPath === mod.path || (mod.path === '/pulse' && currentPath === '/');
            return (
              <li key={mod.id}>
                <Link
                  to={mod.path}
                  onClick={onClose}
                  className={cn(
                    'flex items-center gap-3 px-3 py-3 md:py-2.5 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-blue-600/20 text-blue-400'
                      : 'text-slate-400 hover:bg-zinc-800 hover:text-slate-100'
                  )}
                >
                  <span className="text-base">{mod.icon}</span>
                  <span>{mod.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-zinc-800 shrink-0">
        <p className="text-xs text-zinc-500 text-center">AOS Platform v0.1.0</p>
      </div>
    </aside>
  );
}
